import styled from 'styled-components'
import { COLOR } from '../../../../assets/constants/constants'

export const FooterDiv = styled.div`
  color: #fff;
  grid-row: 3;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-top: 10px;

  @media (max-width: 767px) {
    grid-row: 2;
    font-size: 18px;
    max-height: 200px;
  }
`;

export const ItensDiv = styled.div`
  img {
    margin-right: 20px;
  }
  margin-bottom: 10px;

  @media (min-width: 768px) {
    margin-bottom: 38px;
  }
`;

export const StyledButton = styled.div`
  cursor: pointer;
  border: 1px solid #fff;
  color: #fff;
  width: 154px;
  height: 38px;
  text-align: center;
  padding: 8px 10px;
  font-size: 14px;
  text-transform: uppercase;

  a {
    text-decoration: none;
    color: #fff;
  }

  :hover {
    color: ${COLOR.quaternary};
  }

  @media (max-width: 767px) {
    margin-top: 0;
    position: absolute;
    right: 40px;
    grid-row: 1;
  }
`;

export const StyledClose = styled.div`
  svg {
    width: 2em;
    height: 2em;

    path {
      stroke: #fff;
      stroke-width: 0.78;
    }
  }
`;
